const cn = {
    message: {
        noNet: '暂无网络',
        goCopilot: '分析当晚睡眠及建议',
        goCopilotWeek: '分析这周睡眠情况',
        goCopilotMonth: '分析这月的睡眠情况',
        updateAppTips: '当前版本无法显示，请更新至最新版本！',
        vip: {
            openVip: "开通会员",
            sleepVip: "睡眠会员",
            notOpened: "未开通",
            expired: "已过期",
            validUntil: "有效期至：",
            unlockAll: "解锁全部助眠音",
            trendAnalysis: "睡眠趋势分析",
            reportAnalysis: "专属月报分析",
            deepAnalysis: "深度睡眠分析",
            monthlyVip: "月度会员",
            quarterlyVip: "季度会员",
            annualVip: "年度会员",
            priceEvery: "{price} {oversea}元/月",
            yuanEveryMonth: "{oversea}元/月",
            yuanEveryQuarter: "{oversea}元/季度",
            yuanEveryYear: "{oversea}元/年",
            open: "开通",
            renew: "立即续费",
            renewal: "续费",
            vipMonthExtention: "购买后会员有效期将延长一个月",
            vipQuartyExtention: "购买后会员有效期将延长一个季度",
            vipYearExtention: "购买后会员有效期将延长一年",
            discountLimited: "限时{discount}折",
            discountDuration: "限时折扣活动持续到{date}",
            vipUseDescription1: '解锁全部助眠音',
            vipUseDescription2: '就寝、起床时间趋势',
            vipUseDescription3: '心率、血氧趋势',
        },
        sleep: {
            regularSleep: "常规睡眠",
            nap: "小睡",
            hour: "小时",
            minute: "分钟",
            sleepQuality: "睡眠质量",
            sober: "清醒",
            fastEye: "快速眼动",
            lightSleep: "浅睡",
            darkSleep: "深睡",
            sleepStage: "睡眠阶段",
            suggestRange: "建议睡眠区间",
            avgSleepHeartRate: "平均睡眠心率",
            timesEveryMin: "次/分钟",
            unitsleepbreath: "次/分钟",
            once: "次",
            sleepOxygen: "睡眠血氧饱和度",
            sleepBreath: "睡眠呼吸率",
            highest: "最高",
            lowest: "最低",
            maximum: "最大",
            minimum: "最小",
            normal: "正常",
            average: "平均",
            openMonitoring: "开启监测次数",
            longerMonitor: "监测天数越长越准确",
            avgStatistics: "平均数据统计",
            sleepDuration: "睡眠时长",
            bedTime: "就寝时间",
            getUpTime: "起床时间",
            maxSleep: "最长睡眠时间",
            minSleep: "最短睡眠时间",
            earliestBedTime: "最早就寝时间",
            latestBedTime: "最晚就寝时间",
            earliestGetUpTime: "最早起床时间",
            latestGetUpTime: "最晚起床时间",
            excellent: "优秀",
            good: "良好",
            improvement: "改进",
            importance: "重视",
            sleepEnough: "睡眠充足：{min}-{max}h",
            sleepToLong: "睡眠过长：大于{hour}h",
            sleepDebt: "睡眠不足：小于{hour}h",
            sleepPeriodVary1: "不同年龄的睡眠时段会有差异，您当前填写的年龄为{age}岁",
            sleepPeriodVary2: "不同年龄的睡眠时段会有差异，您当前填写的年龄为{month}个月",
            toSet: "去设置",
            openVipToSee: "开通会员继续查看",
            short_mon: "一",
            short_tue: "二",
            short_wed: "三",
            short_thu: "四",
            short_fri: "五",
            short_sat: "六",
            short_sun: "日",
            mon: "一",
            tue: "二",
            wed: "三",
            thu: "四",
            fri: "五",
            sat: "六",
            sun: "日",
            monday: "周一",
            tuesday: "周二",
            wednesday: "周三",
            thursday: "周四",
            friday: "周五",
            saturday: "周六",
            sunday: "周日",
            day: "日",
            heartRate: "心率",
            bloodOxygen: "血氧饱和度",
            breathRate: "呼吸率",
            noData: "无常规睡眠数据",
            noNapData: "无小睡数据",

            sleepLateTipCommonStart: "您昨晚的入睡时间比理想睡眠时间晚，",
            sleepTipCommonEnd: "保证规律的作息有利于获得好的睡眠。",
            sleepLate3tip: "本周已累计{day}天了，工作很累也要注意休息，",
            sleepLate2TipStart: "您昨晚的入睡时间又比理想睡眠时间晚，",
            sleepLate2Tip: "已经连续2天了，要注意休息，",
            getUpEarlyTip: "您今天的起床时间比理想起床时间早，",
            getUpLateTip: "您今天的起床时间比理想起床时间晚，",
            sleepEarlyTip: "您昨晚的入睡时间比理想睡眠时间早，",

            demoData: "演示数据",
            sleepCompare: "睡眠数据比对",
            seeMore: "查看更多",
            sleepQualityData: "您的睡眠质量为{value}",
            sleepQualityCompare1: "击败了",
            sleepQualityCompare2: "仅高于",
            sleepQualityCompare3: "的用户",
            sleepQualityBestTip: "坚持良好的睡眠可以保障睡眠健康哦～",
            sleepQualityGoodTip: "睡眠质量有待提升啦！",
            sleepQualityBadTip: "请重视起来，让自己拥有一个良好的睡眠",
            sleepTimeText: "您的睡眠时长",
            avgCnSleepTimeText: "中国平均睡眠时长",
            avgGlobalSleepTime: "全球平均睡眠时长",
            sleepTimeTip: "每个人都要保证足够的睡眠时长，这样可以有效的消除疲劳，对身体健康有一定的好处；但是睡眠时间也不要过长哦。",
            bedTimeText: "您的就寝时间",
            avgCnBedTimeText: "中国平均就寝时间",
            avgGlobalBedTime: "全球平均就寝时间",
            bedTimeTip: "就寝时间看起来很简单，实际是一个很关键的指标；养成良好的就寝规律可以保护大脑，变得更容易入睡，也可以提高睡眠质量。",
            getUpTimeText: "您的起床时间",
            avgCnGetUpTimeText: "中国平均起床时间",
            avgGlobalGetUpTime: "全球平均起床时间",
            getUpTimeTip: "起床时间也是一个不可忽视的指标，保证规律的起床时间可以使自己整天都有一个比较良好精神状态。",

            sleepStageTitle: "睡眠阶段分析",
            avgAwakeSleep: "平均清醒",
            avgFastEyeMove: "平均快速眼动",
            avgShallowSleep: "平均浅睡",
            avgDeepSleep: "平均深睡",

            skinTemperature: "睡眠皮肤温度",
            temperatureLow: "偏低",
            temperatureHigh: "偏高",
            reasonableRange: "合理范围",

            compare: {
                dataInsights: '数据洞察',
                today: '今天',
                yesterday: '昨天',
                currentWeek: '本周',
                preWeek: '上周',
                currentMonth: '本月',
                preMonth: '上月',
                daySleepTimeHigher: '今天的睡眠时长比昨天长',
                daySleepTimerLower: '今天的睡眠时长比昨天短',
                daySleepTimerRegular: '近两天的睡眠时长比较规律',

                dayBedTimeEarly: '今天的就寝时间比昨天早',
                dayBedTimeLater: '今天的就寝时间比昨天晚',
                dayBedTimeRegular: '近两天的就寝时间比较规律',

                dayGetupTimeEarly: '今天的起床时间比昨天早',
                dayGetupTimeLater: '今天的起床时间比昨天晚',
                dayGetupTimeRegular: '近两天的起床时间比较规律',
                DayEmptyTip: '昨日没有睡眠记录，坚持佩戴设备睡眠可帮助您了解睡眠数据情况',


                weekSleepTimeHigher: '本周的平均睡眠时长比上周长',
                weekSleepTimerLower: '本周的平均睡眠时长比上周短',
                weekSleepTimerRegular: '近两周的平均睡眠时长比较规律',

                weekBedTimeEarly: '本周平均就寝时间比上周早',
                weekBedTimeLater: '本周平均就寝时间比上周晚',
                weekBedTimeRegular: '近两周的平均就寝时间比较规律',

                weekGetupTimeEarly: '本周平均起床时间比上周早',
                weekGetupTimeLater: '本周平均起床时间比上周晚',
                weekGetupTimeRegular: '近两周的平均起床时间比较规律',
                weekEmptyTip: '上周没有睡眠记录，坚持佩戴设备睡眠可帮助您了解睡眠数据情况',


                monthSleepTimeHigher: '本月的平均睡眠时长比上月长',
                monthSleepTimerLower: '本月的平均睡眠时长比上月短',
                monthSleepTimerRegular: '近两月的平均睡眠时长比较规律',

                monthBedTimeEarly: '本月平均就寝时间比上月早',
                monthBedTimeLater: '本月平均就寝时间比上月晚',
                monthBedTimeRegular: '近两月的平均就寝时间比较规律',

                monthGetupTimeEarly: '本月平均起床时间比上月早',
                monthGetupTimeLater: '本月平均起床时间比上月晚',
                monthGetupTimeRegular: '近两月的平均起床时间比较规律',
                monthEmptyTip: '上月没有睡眠记录，坚持佩戴设备睡眠可帮助您了解睡眠数据情况',

                delete: '删除',
                deleteTitle: '删除日报记录？',
                deleteContent: '删除日报记录后，对应的周报和月报数据都会删除，确定永久删除当前日报数据？',
                confirm: '确认',
                cancel: '取消'

            }
        },
        advert: {
            tip: '早鸟特惠',
            ActivityStartTime: '开始时间',
            ActivityEndTime: '结束时间',
            ActivityEnded: '已结束～',
            buy: '立即抢购',
            explainTitle: '活动说明',
            explainDesc1: '1. 早鸟特惠活动持续时间为2022.12.16～2022.12.31',
            explainDesc2: '2. 活动期间内，您可享受最低4.5折购买会员权益',
            explainDesc3: '3. 充值成功后可在“首页-睡眠卡片-开始睡眠-vip”中查看自己会员的有效期',
            explainDescLast: '4. 本活动最终解释权归mobvoi所有',
            viewVipFunctions: '查看会员功能',
            VipFunctionsExplain: "会员功能说明"
        },
        snore: {
            "snoringDetectionReport": "鼾声检测报告",
            "snoreRecord": "鼾声记录",
            "more": "查看更多",
            "notOpenedTip": "睡觉前，请在“首页-睡眠卡片-开始睡眠-立即睡眠”中打开鼾声监测功能。在睡眠结束后，请记得关闭监测，鼾声纪录将会被自动生成。",
            "noSnoring": "本次睡眠未打鼾～",
            "snoreData": "鼾声数据",
            "snoreReport": "鼾声报告",
            "snoreDuration": "时长",
            "avgSnoreDb": "平均分贝",
            "maxSnoreDb": "最大分贝",
            "minSnoreDb": "最小分贝",
            "snoreDbRatio": "鼾声分贝占比",
            "snoreWaveforms": "鼾声波纹趋势",
            "snoreFrequency": "打鼾频率分布",
            "snoreFrequencyTrend": "打鼾频率趋势",
            "low": "低频",
            "medium": "中频",
            "high": "高频",
            "softSnore": "软腭打鼾",
            "uvulaSnore": "会厌打鼾",
            "tongueSnore": "舌后打鼾",
            "snoreRecordSetting": "设置",
            "storageMethods": "存储方式",
            "storageDurations": "存储时长",
            "local": "本地",
            "cloud": "云端",
            "localStorage": "本地存储",
            "cloudStorage": "云端存储",
            "storageWayTips": "您可以选择将您的鼾声数据存储在本地或云端；存储在本地将会占据您的存储空间；存储在云端需要开通睡眠会员权限，最多可以为您保留180天的数据",
            "storagePeriod": "您可以选择鼾声数据的存储时间，为了保护您的数据安全呢，我们设置了最短1天，最长180天的存储时长；若您选择1天，则第二天会将您的鼾声数据清除；开通会员后可享受30天和180天的存储时长",
            "storagePeriodWearCopilot": "您可以选择鼾声数据的存储时间。",
            "day": "天",
            "days": "天",
            recordSnoreTitle1: '1.记录鼾声',
            recordSnoreContent1: '每晚睡前开启鼾声检测功能，起床后记得手动结束睡眠，记录完整的鼾声数据。',
            recordSnoreTitle2: '2.日报中查看鼾声记录',
            recordSnoreContent2: '在日报中可以查看到3条鼾声记录，点击可播放自己的鼾声记录。',
            recordSnoreTitle3: '3.更多鼾声数据分析',
            recordSnoreContent3: '日报中点击查看更多，可以看到全部鼾声记录并对鼾声分贝、波纹、分布、频率等进行分析。',
            "tips": "提示",
            "vipTips": "开启该功能需要开通睡眠会员，立即开通睡眠会员？",
            "open": "立即开通",
            "noAudioTip": "鼾声音频加载中，请稍后再试",
        },
    },
}

export default cn
